import { AgentBroker } from '../../core/domain/agentBroker.model'
import { CustomerLead } from '../../core/domain/customerLead.model'
import { OfferData } from '../../core/domain/offerData.model'
import { OfferDocument } from '../../core/domain/offerDocument.model'

export const fakeInitOffer: OfferData = {
  id: 1,
  numberOfVehicles: 0,
  vehiclesToEnsure: 0,
  plate1: '',
  plate2: '',
  plate3: '',
  plate4: '',
  plate5: '',
  globalInsured: 0,
  insuredVehicle1: undefined,
  insuredVehicle2: undefined,
  insuredVehicle3: undefined,
  insuredVehicle4: undefined,
  insuredVehicle5: undefined,
  deductible: 0,
  transCH: 100,
  transEurope: 0,
  transRemoval: 0,
  transTheft: 0,
  liability: '',
  prevInsurance: 0,
  numberOfClaims: 0,
  claimLoses: 0,
  years: 5,
  cancelledPreviousInsurance: 0,
  progressMask: '0000000',
}

export const fakeInitCustomer: CustomerLead = {
  userName: '',
  company: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  country: '',
  city: '',
  postalAddress: '',
  postalCode: '',

  reqContact: 0,
  acceptedPrivacyPolicy: 0,
  informedTermsAndConditions: 0,
}

export const fakeInitDocument: OfferDocument = {
  id: '1',
  customerId: '314',
  agentId: '007',
  offerDataId: '2',
  price: 190000,
  pricingDate: new Date(2019, 4, 1),
  creationDate: new Date(2019, 4, 1),
  contractingDate: new Date(2019, 5, 1),
  validityStartDate: null,
  validityInYears: 1,
  discarded: false,
}

export const fakeInitAgent: AgentBroker = {
  id: '',
  userName: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  agentBrokerNumber: '',
  agencyId: 0,
  role: '',
}
